import { render, staticRenderFns } from "./AssetTypeDetailsView.vue?vue&type=template&id=06d3e6b2&scoped=true"
import script from "./AssetTypeDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetTypeDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeDetailsView.vue?vue&type=style&index=0&id=06d3e6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3e6b2",
  null
  
)

export default component.exports